import React, { Component } from 'react';

class RequestToJoinOrgErrorMessageModal extends Component {
	// useless constructor warning
	// constructor(props) {
	// 	super(props);
	// }
	
	componentDidUpdate(prevProps, prevState) {
		if(prevProps.showRequestToJoinOrgErrorMessageModal !== this.props.showRequestToJoinOrgErrorMessageModal){
			if(this.props.showRequestToJoinOrgErrorMessageModal) {
				this.joinOrgErrorMessageModalOpen.click();
				this.props.closeRequestToJoinOrgErrorMessageModal();
			}
		}
	}

	render () {

		return (
          <div>
          <input type="hidden" ref={elem => this.joinOrgErrorMessageModalOpen = elem} id="JoinOrgErrorMessageModalOpen" data-bs-toggle="modal" data-bs-target="#JoinOrgErrorMessageModal"/>
  			<div className="modal fade" id="JoinOrgErrorMessageModal" tabIndex="-1" role="dialog" aria-labelledby="JoinOrgErrorMessageModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                 <div className="modal-content">
                   <div className="modal-header">FirstNet Developer Program</div>
                   <div className="modal-body">
                   		{this.props.requestToJoinOrgErrorMessage}
                   </div>
                   <div className="modal-footer">
                   	<button className='btn btn-primary' data-bs-dismiss="modal" name="OK">
           				OK
           			</button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
		)
	}
}

export default RequestToJoinOrgErrorMessageModal;



// WEBPACK FOOTER //
// ./src/manageMyAccount/modals/RequestToJoinOrgErrorMessageModal.js